import { render } from "./Box.vue?vue&type=template&id=c5add3d4&scoped=true&ts=true"
import script from "./Box.vue?vue&type=script&lang=ts"
export * from "./Box.vue?vue&type=script&lang=ts"

import "./Box.scss?vue&type=style&index=0&id=c5add3d4&scoped=true&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5add3d4"]])

export default __exports__